export default "__VITE_ASSET__CcR$BQGQ__"